




import { Component } from "vue-property-decorator"
import Preview from "./Preview.vue"

@Component({
  components: { Preview },
})
export default class ThirdPartyCheck extends Preview {
  public created(): void {
    const type = "sp"
    const message = "こちらにアクセス(有効期限: 30日間)"
    const expiredTime = 2592000 // 1month = 720h * 60 minutes * 60 seconds

    this.postPreview(type, message, expiredTime)
  }
}
